import { memo } from 'react'
import List from './list'

const DownloadCenter = () => {
  return (
    <div className="w-full h-full flex flex-col">
      <List />
    </div>
  )
}

export default memo(DownloadCenter)
